


const configureSomaticQuery = (query_to_run, analyses, somatic_query_default, props, selectedDir) => {
    // Case when switching between analyses
    if (analyses && analyses.samples_somatic && analyses.samples_somatic.length > 0) {
        query_to_run.samples_somatic = analyses.samples_somatic[0].gt_settings;
    }
    // Case of going to the first analysis already preconfigured
    else if (analyses && !analyses.samples_somatic) {
        query_to_run.samples_somatic = JSON.parse(JSON.stringify(somatic_query_default.ref_samples_somatic));
    }
    // Case of a new query
    else {
        query_to_run.samples_somatic = props.somatic_samples[0].gt_settings;
    }

    // Get tumor & control experiment IDs from the corresponding DIR
    const tumor_experiment_id = selectedDir.tumor_experiment_id || "";
    const control_experiment_id = selectedDir.control_experiment_id || "";

    query_to_run.samples_somatic[0].sample_id_tumor = tumor_experiment_id;
    query_to_run.samples_somatic[0].sample_id_control = control_experiment_id;

    // Case of somatic tumor only (without control)
    if (selectedDir.analysis === "somatic_tumor_only") {
        delete query_to_run.samples_somatic[0].sample_id_control;
        delete query_to_run.samples_somatic[0].dp_control;
        delete query_to_run.samples_somatic[0].ad_control;
        delete query_to_run.samples_somatic[0].pass_control;
    }

    return query_to_run;
};

export default configureSomaticQuery;